import PropTypes from 'prop-types';
// @mui
import { useTheme } from '@mui/material/styles';
import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
// utils
import { fNumber } from 'src/utils/format-number';
// components
import Chart from 'src/components/chart';

// ----------------------------------------------------------------------
export default function HeaderAnalytics({ title, totalInvoices, amount, chart, sx, ...other }) {
    const theme = useTheme();

    const {
        colors = [theme.palette.primary.light, theme.palette.primary.main],
        series,
        options,
    } = chart;

    const chartOptions = {
        colors,
        fill: {
            type: 'bar',
            gradient: {
                colorStops: [
                    { offset: 0, color: colors[0] },
                    { offset: 100, color: colors[1] },
                ],
            },
        },
        chart: {
            sparkline: {
                enabled: true,
            },
        },
        plotOptions: {
            bar: {
                columnWidth: '68%',
                borderRadius: 2,
            },
        },
        tooltip: {
            enabled: false,
        },
        // tooltip: {
        //     x: { show: false },
        //     y: {
        //         formatter: (value) => fNumber(value),
        //         title: {
        //             formatter: () => '',
        //         },
        //     },
        //     marker: { show: false },
        // },
        ...options,
    };

    return (
      <>
            <Box sx={{ display:'flex', flexDirection: 'column' , justifyContent:'space-between', alignItems: 'center', height: '280px', gap: 2}}>
                {/* <Stack direction="row" alignItems="center"></Stack> */}
                <Box >
                <Typography variant="h6">{title}</Typography>
                <Typography variant="h4" sx={{color: 'green'}}>{ `${fNumber(totalInvoices)}`}</Typography>
                {/* <Typography variant="h4" sx={{color: 'green'}}>{ `$${fNumber(amount)}`}</Typography> */}
                </Box>
            <Chart type="bar" series={[{ data: series }]} options={chartOptions} width={80} height={50} />
            </Box>
            </>
    );
}

HeaderAnalytics.propTypes = {
    chart: PropTypes.object,
    sx: PropTypes.object,
    title: PropTypes.string,
    total: PropTypes.number,
};
